module.exports = __webpack_public_path__ + "img/rewards.9792b19d.png";